export default __webpack_public_path__ + "assets/images/logo.eb7982cdf6b5c7df501fbcf70dfacac5.svg";